





















































































import { Component, Prop } from 'vue-property-decorator';
import { getModule } from "vuex-module-decorators";
import Vue from 'vue';
import Apps from "@/store/modules/Apps"
import CardTitle from '@/components/common/CardTitle.vue';
import AppsAddRenameDialog from "@/components/apps/AppsAddRenameDialog.vue";
import AppsAdditionalMenu from "@/components/apps/AppsAdditionalMenu.vue";
import AppsShareLink from '@/components/apps/AppsShareLink.vue';
import Decisions from "@/store/modules/Decisions";
import CardDesign from '@/components/apps/CardDesign.vue';

const appsModule = getModule(Apps);
const decisionsModule = getModule(Decisions);

@Component({
    components: { 
        CardTitle,
        AppsAddRenameDialog,
        AppsAdditionalMenu,
        AppsShareLink,
        CardDesign
    },
})
export default class AppsSelector extends Vue {
    @Prop({default: false, type: Boolean})
    mainApp!: boolean;

    private loadingResources = false;
    private processing = false;

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get selectedAppId() {
        return appsModule.appId;
    }

    get selectedApp() :any {
        if (this.selectedAppId){
            return appsModule.appsDictionary[this.selectedAppId];
        } else {
            return null;
        }
    }
    
    get selectedAppHasHomepage() {
        if (this.selectedApp && this.selectedApp.homepage && this.selectedApp.homepage !== '') {
            return true;
        } else {
            return false;
        }
    }
    get loading() {
        return this.loadingResources
            || this.processing;
    }

    get apps(){
        return appsModule.appList;
    }

    get appLabel(){
        return this.selectedAppId ? "" : "Please create or select an Applet";
    }

    set selectedAppId(id:string){
        appsModule.setSelectedAppId(id);
    }
}
